
import { Component, Emit, Prop } from '@modules/vue-property-decorator';
import Vue from 'vue';
import CircleIcon from './circleIcon.vue';

export interface ContainerConfig {
  titleAlign: 'left' | 'center' | 'right';
  title: string;
  showCloseButton: boolean;
  showHeader: boolean;
  showFooter: boolean;
  imgSrc: string | null;
  selected: boolean;
}

@Component({
  components: {
    CircleIcon,
  },
})
export default class Container extends Vue {
  @Prop() config?: Partial<ContainerConfig>;
  private readonly defaultConfig: ContainerConfig = {
    titleAlign: 'left',
    title: '',
    showCloseButton: false,
    showHeader: false,
    showFooter: false,
    imgSrc: null,
    selected: false,
  };

  private get currentConfig() {
    if (this.config) {
      return {
        ...this.defaultConfig,
        ...this.config,
      };
    }
    return this.defaultConfig;
  }

  private get titleClass() {
    switch (this.currentConfig.titleAlign) {
      case 'left':
        return 'text-left';
      case 'center':
        return 'text-center';
      case 'right':
        return 'text-right';
    }
  }
  private get clickable(): boolean {
    return !!this.$listeners['click'];
  }

  @Emit('close')
  private onCloseClick(payload: MouseEvent) {

  }
}

